// extracted by mini-css-extract-plugin
export default {"container":"ima_PPEqm"};